module.exports = __webpack_public_path__ + "static/logo_white-02462412cc874ff93061df85c3797ae8.png";